import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  flex: 1;
  padding-right: 16px;
  padding-bottom: 32px;
`;
